import { render } from "./complete-sliders.vue?vue&type=template&id=efdebd50&ts=true"
import script from "./complete-sliders.vue?vue&type=script&lang=ts"
export * from "./complete-sliders.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__